/** Nessuna chiamata backend verso risorse legate all’app (faq, probe features qrcode/nps, …) */
export function skipBackendProbeForApp(app: string): boolean {
  const code = typeof app === 'string' ? app.trim() : '';
  return code.length === 0 || code.toLowerCase() === 'workspace';
}
